import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import ScrollAnimation from 'react-animate-on-scroll';

import project1 from '../assets/images/project1.jpg';
import project2 from '../assets/images/project2.jpg';
import project3 from '../assets/images/project3.jpg';
import project4 from '../assets/images/project4.jpg';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "5px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        height: "400px",
        [theme.breakpoints.down("md")]: {
            height: "300px",
        },
        "&:hover": {
            "& div": {
                opacity: 1
            }
        }
    },
    detailBox: {
        height: "100%",
        padding: "20px",
        backgroundImage: `linear-gradient(to bottom, #ffffff00,${theme.palette.primary.main} )`,
        cursor: "pointer",
        transition: "0.5s",
        opacity: 0
    },
    detailTitle: {
        color: theme.palette.common.white
    },
    detailSubtitle: {
        color: theme.palette.common.white
    },
    more: {
        width: "25%",
        border: `solid ${theme.palette.primary.main} 1px`,
        cursor: "pointer",
        transition: "0.5s",

        [theme.breakpoints.down("md")]: {
            fontSize: "14px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "10px",
        },

        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        },
    },
}))


export default function Projects() {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    const [dialogChk, setDialogChk] = React.useState(0);

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.container} id="projects">

                <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                    <Grid item>
                        <Typography component="h1" variant="h2" gutterBottom>PROJECTS</Typography>
                    </Grid>
                    <Grid item>
                        <Typography component="h1" variant="h1" paragraph>Our Photo Collection</Typography>
                    </Grid>
                </ScrollAnimation>

                <Grid item container direction="row" spacing={2}>
                    <Grid item md={5} sm={6} xs={12} className={classes.box}>
                        <Grid item
                              onClick={() => {
                                  setDialogChk(1)
                              }}
                              style={{
                                  backgroundImage: `url(${project1})`,
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  height: "100%"
                              }}>
                            <Grid item container direction="column" justify="space-between"
                                  className={classes.detailBox}>
                                <Grid item>
                                </Grid>
                                <Grid item>
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Optometry</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Office</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Dialog fullWidth={true} maxWidth="md" open={dialogChk === 1} onClose={() => setDialogChk(0)}
                                style={{userSelect: "none"}}>
                            <img src={project1} alt="home remodeling" style={{width: "100%", height: "100%"}}/>
                        </Dialog>
                    </Grid>
                    <Grid item md={7} sm={6} xs={12} className={classes.box}>
                        <Grid item
                              onClick={() => {
                                  setDialogChk(2)
                              }}
                              style={{
                                  backgroundImage: `url(${project2})`,
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  height: "100%"
                              }}>
                            <Grid item container direction="column" justify="space-between"
                                  className={classes.detailBox}>
                                <Grid item>
                                </Grid>
                                <Grid item>
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Optometry</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Office</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Dialog fullWidth={true} maxWidth="md" open={dialogChk === 2} onClose={() => setDialogChk(0)}
                                style={{userSelect: "none"}}>
                            <img src={project2} alt="remodeling contractors near me"
                                 style={{width: "100%", height: "100%"}}/>
                        </Dialog>
                    </Grid>
                    <Grid item md={7} sm={6} xs={12} className={classes.box}>
                        <Grid item
                              onClick={() => {
                                  setDialogChk(3)
                              }}
                              style={{
                                  backgroundImage: `url(${project3})`,
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  height: "100%"
                              }}>
                            <Grid item container direction="column" justify="space-between"
                                  className={classes.detailBox}>
                                <Grid item>
                                </Grid>
                                <Grid item>
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Dental</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Office</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Dialog fullWidth={true} maxWidth="md" open={dialogChk === 3} onClose={() => setDialogChk(0)}
                                style={{userSelect: "none"}}>
                            <img src={project3} alt="home remodeling" style={{width: "100%", height: "100%"}}/>
                        </Dialog>
                    </Grid>
                    <Grid item md={5} sm={6} xs={12} className={classes.box}>
                        <Grid item
                              onClick={() => {
                                  setDialogChk(4)
                              }}
                              style={{
                                  backgroundImage: `url(${project4})`,
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  height: "100%"
                              }}>
                            <Grid item container direction="column" justify="space-between"
                                  className={classes.detailBox}>
                                <Grid item>
                                </Grid>
                                <Grid item>
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Dental</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography component="h1" variant="h3"
                                                        className={classes.detailSubtitle}>Office</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Dialog fullWidth={true} maxWidth="md" open={dialogChk === 4} onClose={() => setDialogChk(0)}
                                style={{userSelect: "none"}}>
                            <img src={project4} alt="home renovations" style={{width: "100%", height: "100%"}}/>
                        </Dialog>
                    </Grid>

                </Grid>

                <Grid item style={{marginTop: "50px", marginBottom: "50px"}}>
                    <Button component={Link} href={"/projects"} variant="contained" color="primary">
                        View All Projects &#8594;
                    </Button>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
